import { IOrgMemberRole } from '@/types/IOrgMember';
import { Tag } from '@chakra-ui/react';

interface IProps {
	role: IOrgMemberRole;
}

export default function MemberRole(props: IProps) {
	switch (props.role) {
		case 'ADMIN':
			return (
				<Tag size="sm" colorScheme="yellow">
					Admin
				</Tag>
			);
		case 'MEMBER':
			return (
				<Tag size="sm" colorScheme="blue">
					Member
				</Tag>
			);
		case 'OWNER':
			return (
				<Tag size="sm" colorScheme="red">
					Owner
				</Tag>
			);
	}
}
